import React from 'react';
import { buildYoutubeEmbedUrl } from 'utils/youtube';
import { block } from './utils';

export type VideoWizardYoutubeEmbedProps = {
  videoId: string;
};

const VideoWizardYoutubeEmbed: React.FC<VideoWizardYoutubeEmbedProps> = ({
  videoId,
}) => (
  <div className={block('youtube-embed')}>
    <iframe
      className={block('youtube-embed-iframe')}
      src={buildYoutubeEmbedUrl(videoId)}
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
    />
  </div>
);

export default VideoWizardYoutubeEmbed;
